/**
 * Dropzone boot config. Imported for its side effect before any uploader runs.
 *
 * Auto-discover would otherwise attach an uploader to every `.dropzone` element
 * on DOMContentLoaded; every uploader in this app is constructed explicitly with
 * its own presign → PUT → complete pipeline, so discovery must stay off.
 */
import Dropzone from "dropzone";

Dropzone.autoDiscover = false;
